export default __webpack_public_path__ + "static/media/s11.e48bba7a.jpg";